import React, { useState } from 'react';
import styles from './ToggleButton.module.css';

const ToggleButton = ({ options, defaultSelected, onChange }) => {
    const [selected, setSelected] = useState(defaultSelected || options[0]);

    const handleToggle = (option) => {
        setSelected(option);
        if (onChange) {
            onChange(option);
        }
    };

    return (
        <div className={styles.toggleContainer}>
            {options.map((option, index) => (
                <button
                    key={index}
                    className={`${styles.toggleButton} ${selected === option ? styles.active : ''}`}
                    onClick={() => handleToggle(option)}
                >
                    {option}
                </button>
            ))}
        </div>
    );
};

export default ToggleButton;
